<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-file-upload`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M40 2a2 2 0 012 2l-.001 20h-4L38 6H10v36h14v4H8a2 2 0 01-2-2V4a2 2 0 012-2h32zm-3.636 25.707l7.071 7.071a1 1 0 010 1.414l-1.414 1.415a1 1 0 01-1.414 0l-2.937-2.938V45a1 1 0 01-1 1h-2a1 1 0 01-1-1V34.642l-2.963 2.965a1 1 0 01-1.414 0l-1.414-1.415a1 1 0 010-1.414l7.07-7.07a1 1 0 011.415 0zM25 22a1 1 0 011 1v2a1 1 0 01-1 1H15a1 1 0 01-1-1v-2a1 1 0 011-1h10zm8-8a1 1 0 011 1v2a1 1 0 01-1 1H15a1 1 0 01-1-1v-2a1 1 0 011-1h18z"/></svg>
</template>
<script>

export default {
  name: 'IconFileUpload',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
